import RequestPopupPreAuthorization from './RequestPopupPreAuthorization';

export default RequestPopupPreAuthorization;